import React from "react";
import { css } from "emotion";
import GenericCard from "../GenericCard";
import { textSizes, colors, boxStyles } from "../../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StatCard = ({ stat, desc }) => {
  let icon = "circle";
  switch (desc) {
    case "views":
      icon = "eye";
      break;
    case "plays":
      icon = "play";
      break;
    case "finishes":
      icon = "check";
      break;
    case "CTA Clicks":
      icon = "mouse-pointer";
      break;
    default:
      icon = "circle";
      break;
  }
  return (
    <GenericCard style={container}>
      <FontAwesomeIcon className="icon" icon={icon} />
      <h3>{stat}</h3>
      <p>{desc}</p>
    </GenericCard>
  );
};

export default StatCard;

const container = css`
  justify-content: center;
  align-items: center;
  width: 20%;
  flex-direction: column;
  padding: ${boxStyles.desktopPadding} ${boxStyles.standardPadding};
  .icon {
    color: ${colors.brandColor};
    font-size: 24px;
    margin-bottom: 10px;
  }
  h3 {
    font-size: ${textSizes.title};
    font-weight: normal;
  }
  p {
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    text-transform: capitalize;
  }
  @media screen and (max-width: ${boxStyles.desktopBreak}) {
    width: 40%;
    margin-bottom: 20px;
  }
`;
